import parseVivaTopicFileSuggestions from './parseVivaTopicFileSuggestions';
import parseVivaTopicPeopleSuggestions from './parseVivaTopicPeopleSuggestions';
import parseVivaTopicEntitySuggestions from './parseVivaTopicEntitySuggestions';
import type { SonoraVivaTopicSuggestion, SonoraVivaTopicEntity } from 'owa-editor-sonora-types';
import { trace } from 'owa-trace';
import type { Suggestion } from 'owa-userdataservice';
import isSonoraPluginVivaTopicFileSuggestionsEnabled from './isSonoraPluginVivaTopicFileSuggestionsEnabled';
import isSonoraPluginVivaTopicPeopleSuggestionsEnabled from './isSonoraPluginVivaTopicPeopleSuggestionsEnabled';
import isSonoraPluginVivaTopicEntitySuggestionsEnabled from './isSonoraPluginVivaTopicEntitySuggestionsEnabled';

export default function parseVivaTopicSuggestions(
    suggestion: Suggestion
): SonoraVivaTopicSuggestion | undefined {
    try {
        const fileSuggestions = isSonoraPluginVivaTopicFileSuggestionsEnabled()
            ? parseVivaTopicFileSuggestions(suggestion)
            : null;
        const peopleSuggestions = isSonoraPluginVivaTopicPeopleSuggestionsEnabled()
            ? parseVivaTopicPeopleSuggestions(suggestion)
            : null;
        const entitySuggestions = isSonoraPluginVivaTopicEntitySuggestionsEnabled()
            ? parseVivaTopicEntitySuggestions(suggestion)
            : null;

        const suggestions: SonoraVivaTopicEntity[] = [];

        if (entitySuggestions) {
            suggestions.push(...entitySuggestions);
        }
        if (fileSuggestions) {
            suggestions.push(...fileSuggestions);
        }

        if (peopleSuggestions) {
            suggestions.push(...peopleSuggestions);
        }

        return {
            suggestions: suggestions,
            logicalId: undefined,
            traceId: undefined,
        };
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseVivaTopicSuggestions] Error: ${error}`);
    }
    return undefined;
}
